import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { DEFAULT_API } from "../routes/api.routes";

export const baseApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: DEFAULT_API,
    prepareHeaders: (headers, { getState }) => {
      headers.set("Connection", "keep-alive"); // Ensures HTTP/2 persistence
      
      // Récupérer le token depuis le state Redux
      const state = getState();
      const token = state?.user?.currentUser?.token || state?.user?.currentUser?.token?.token;
      
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      
      return headers;
    },
  }),
  // refetchOnReconnect: true,
  keepUnusedDataFor: 86400,
  reducerPath: "genimiWeb",
  endpoints: () => ({}),
});

export const ApiMananger = baseApi.enhanceEndpoints({
  addTagTypes: [
    "Coachs",
    "Parents",
    "Fiches",
    "Users",
    "Eleves",
    "Appels",
    "comprehensions",
    "Paiements",
    "Evaluations",
    "Niveaux",
    "Classes",
    "Ecoles",
    "Diagnostics",
    "DiagnosticParents",
    "Villes",
    "Epreuves",
    "Notes",
    "Kpi",
    "Waves",
    "Maitres",
    "Directeurs",
    "Partenaires",
    "FeatureUsage",
  ],
});
